/// <amd-module name="Environments/EnvironmentDetails/Actions/EnvironmentActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { IEnvironmentObject, IEnvironmentResourceObject } from "Environments/Client/EnvironmentContracts";

export class EnvironmentActions extends ActionsHubBase {

    public static getKey(): string {
        return "environment-actions";
    }

    public initialize(instanceId?: string) {
        this._updateEnvironment = new Action<IEnvironmentObject>();
        this._setEnvironment = new Action<IEnvironmentObject>();
        this._deleteResource = new Action<number>();
        this._updateResources = new Action<IEnvironmentResourceObject[]>();
    }

    public get updateEnvironment(): Action<IEnvironmentObject> {
        return this._updateEnvironment;
    }

    public get setEnvironment(): Action<IEnvironmentObject> {
        return this._setEnvironment;
    }

    public get deleteResource(): Action<number> {
        return this._deleteResource;
    }

    public get updateResources(): Action<IEnvironmentResourceObject[]> {
        return this._updateResources;
    }

    private _updateEnvironment: Action<IEnvironmentObject>;
    private _setEnvironment: Action<IEnvironmentObject>;
    private _deleteResource: Action<number>;
    private _updateResources: Action<IEnvironmentResourceObject[]>;
}
